/*
 * Selectors using reselect.
 */
import { createSelector } from 'reselect';
import { calculateNumberOfNights } from 'utils/dateUtils';

const rootSelector = state => state.app.dateSelection;

export const startDateSelector = createSelector(
  rootSelector,
  subState => subState.startDate
);

export const endDateSelector = createSelector(
  rootSelector,
  subState => subState.endDate
);

export const numberOfNightsSelector = createSelector(
  startDateSelector,
  endDateSelector,
  (startDate, endDate) => calculateNumberOfNights(startDate, endDate)
);

export const propertySelector = createSelector(
  rootSelector,
  subState => subState.property
);

export const numberOfGuestsSelector = createSelector(
  rootSelector,
  subState => subState.numberOfGuests
);

export const queryInputSelector = createSelector(
  rootSelector,
  subState => subState.queryInput
);

export const accountNumberSelector = createSelector(
  rootSelector,
  subState => subState.accountNumber
);

export const accountPinSelector = createSelector(
  rootSelector,
  subState => subState.accountPin
);

export const submittedAccountSelector = createSelector(
  rootSelector,
  subState => subState.submittedAccount
);

export const blockCodeSelector = createSelector(
  rootSelector,
  subState => subState.blockCode
);

export const submittedBlockCodeSelector = createSelector(
  rootSelector,
  subState => subState.submittedBlockCode
);

export const activeBlockSelector = createSelector(
  rootSelector,
  subState => subState.activeBlock
);

export const selectedOffersSelector = createSelector(
  rootSelector,
  subState => subState.selectedOffers
);

export const isAdminSelector = createSelector(
  rootSelector,
  subState => subState.isAdmin
);

export const secondAccountNumberSelector = createSelector(
  rootSelector,
  subState => subState.secondAccountNumber
);

export const secondSubmittedAccountSelector = createSelector(
  rootSelector,
  subState => subState.secondSubmittedAccount
);

export const isWaitListBookingSelector = createSelector(
  rootSelector,
  subState => subState.isWaitListBooking
);

export const waitListBookingReasonSelector = createSelector(
  rootSelector,
  subState => subState.waitListBookingReason
);

export const waitListBookingCommentSelector = createSelector(
  rootSelector,
  subState => subState.waitListBookingComment
);

export const adminSelectedOffersSelector = createSelector(
  rootSelector,
  subState => subState.adminSelectedOffers
);

export const hotelOverrideCodesSelector = createSelector(
  rootSelector,
  subState => subState.hotelOverrideCodes
);

export const maxStayExceededSelector = createSelector(
  rootSelector,
  subState => subState.maxStayExceeded
);
